export const updateAddressFields = (locationType, setFieldValue, address) => {
  const fieldPrefix = `${locationType}.locationAddress`;
  setFieldValue(`${fieldPrefix}.address1`, address.address1);
  setFieldValue(`${fieldPrefix}.address2`, address.address2);
  setFieldValue(`${fieldPrefix}.city`, address.city);
  setFieldValue(`${fieldPrefix}.state`, address.state);
  setFieldValue(`${fieldPrefix}.postalCode`, address.postalCode);
  setFieldValue(`${fieldPrefix}.country`, address.country);
};

export const getContactSuggestions = async (contacts, searchTerm) => {
  const regex = new RegExp('\\b' + searchTerm, 'i');
  const suggestionResults = contacts.filter(contact => {
    return regex.test(contact.title);
  });

  const suggestions = suggestionResults.map(result => {
    return {
      label: result.title,
      ...result
    };
  });

  return Promise.resolve(suggestions);
};
export const getContactById = (contactId, contacts) => {
  return contacts.find(contact => {
    if (contact.data.id === String(contactId)) {
      return true;
    }
    return false;
  });
};
